import type { AlignType } from '../types';

export const computeAlignment = (alignment?: AlignType) => {
  if (!alignment) return 'flex-start';

  return alignment === 'left' ? 'flex-start' : alignment === 'center' ? 'center' : 'flex-end';
};
